export const listCheckCopy = {
  select: 'Select',
  noMatch: 'No match',
  undo: 'Undo this answer',
  previous: 'Previous',
  next: 'Next',
  noExampleDocument: 'No example document',
  rulingException: 'Ruling exception',
  rowNotes: 'Row notes',
  download: 'Download',
  documentUnderReview: 'Document under review',
  candidate: (position: number) => `Candidate ${position}`,
  comparisonTitle: {
    profile: 'Example PDF',
    rule: 'List rule',
    text: 'Document text',
    registry: 'Registry row'
  },
  differCount: (count: number, total: number) => `${count} of ${total} differ`,
  matchCount: (count: number, total: number) => `${count} of ${total} match`,
  foundCount: (count: number, total: number) => `${count} of ${total} found`,
  matchPercent: (percent: number) => `${percent}% match`,
  closeCount: (count: number) => ` · ${count} close`,
  checkProvider: 'Check the provider',
  thisDocument: 'This document',
  rule: 'Rule',
  sameColumns: (columns: string[]) => `Same: ${columns.join(', ')}`,
  status: {
    differs: 'Differs',
    match: 'Match',
    noMatch: 'No match',
    found: 'Found',
    notFound: 'Not found',
    close: 'Close',
    check: 'Check'
  },
  notOnList: 'Not on list',
  closest: (line: string) => `Closest: ${line}`,
  notRead: 'Not read',
  blank: 'Blank',
  yourPick: 'Your pick',
  copyId: 'Copy ID',
  openRow: 'Open this row in the Atlas sheet',
  idCopied: (id: string) => `${id} copied`,
  selected: 'Selected',
  answeredBy: 'Answered by you',
  justNow: 'just now',
  youPicked: 'You picked',
  youAnswered: 'You answered',
  modalTitle: 'None of these match?',
  modalLead: (count: number, name: string) =>
    count === 1
      ? `We found 1 close match on the ${name} list. It wasn't exact.`
      : `We found ${count} close matches on the ${name} list, but no exact match.`,
  modalRecord:
    'Confirming will record this check as No Match. Your answer replaces the automated result.',
  modalGoBack: (count: number) =>
    count === 1
      ? 'If this is a match, go back and select it.'
      : 'If one of these is a match, go back and select it.',
  modalConfirm: 'Confirm no match',
  noMatchModalTitle: 'No match?',
  noMatchNoteLabel: 'Why is this not a match?',
  mismatchModalTitle: 'Provider mismatch?',
  mismatchModalLead:
    "Confirming will record the document's payroll provider as not matching the registry.",
  mismatchNoteLabel: 'Why is this a mismatch?',
  mismatchModalConfirm: 'Confirm mismatch',
  modalCancel: 'Go back',
  company: 'Company',
  expectedProvider: 'Expected payroll provider',
  registeredProviders: 'Registered providers',
  registryRow: 'Registry row',
  match: 'Match',
  mismatch: 'Mismatch',
  registryUnread:
    'The engine could not read the payroll provider off the document. Check the document and answer Match or Mismatch.',
  overviewTab: 'Overview',
  matchedTemplate: 'Matched template:',
  textPropertiesTab: 'Text properties',
  bytecodeTab: 'Bytecode',
  noBytecode: 'No byte code found',
  bytecodeTruncated: (shown: number, total: number) =>
    `Showing the first ${shown.toLocaleString()} of ${total.toLocaleString()} characters`,
  analyzing: 'Analyzing document…',
  xrayFailed: "X-Ray couldn't read this document.",
  retry: 'Retry',
  noTextFound: 'No text found',
  page: (n: number) => `Page ${n}`,
  font: 'Font',
  color: 'Color',
  text: 'Text',
  resolutionFailed: 'The check could not be updated. Please try again.',
  resolutionConflict: 'This check was already answered by someone else. Refresh to see the latest.',
  edited: 'Edited',
  notEdited: 'Not edited',
  fraudTrendLede: {
    blocked: 'Gamma Ray found signs this document was edited.',
    consistent: 'Gamma Ray found no signs this document was edited.',
    inconclusive: "Gamma Ray couldn't tell whether this document was edited."
  },
  fraudTrendPrompt: 'Check the document and answer Edited or Not edited.',
  fraudTrendAgreePrompt: 'Check the document, then agree or disagree with Gamma Ray.',
  agree: 'Agree',
  disagree: 'Disagree',
  youAgreed: (ruled: string) => `You agreed with this check. Ruled ${ruled}`,
  youDisagreed: (ruled: string) => `You disagreed with this check. Ruled ${ruled}`,
  youRuled: (ruled: string) => `You ruled ${ruled}`,
  disagreeModalTitle: 'Disagree with this check?',
  disagreeModalLead: (ruled: string) =>
    `Confirming will record this document as ${ruled}. Your answer replaces the automated result.`,
  disagreeNoteLabel: 'Why do you disagree?',
  disagreeModalConfirm: (ruled: string) => `Confirm ${ruled}`,
  advancedFraudTrends: {
    couldNotTell: "Couldn't tell",
    loading: "Loading the check's findings…",
    unavailable: "The check's findings aren't available",
    noResults: 'No findings for this pattern',
    overviewIntro:
      'Each tile is one editing trick Gamma Ray checked on this document. Open its tab to see what it found.',
    ruleLabel: (n: number) => `Rule ${n}`,
    rulesFound: (total: number) =>
      ` of ${total} rule ${total === 1 ? 'sub-check' : 'sub-checks'} found something`,
    countLine: (label: string, count: number | null) =>
      count === null ? label : `${label}: ${count}`,
    headerBarsHowTo: (page: number) =>
      `To check yourself: copy the header on page ${page} and paste it into a text editor.`,
    headerBarsAsExpected: (bar: string, pages: number) =>
      `Header bars copy as ${bar} on ${
        pages === 1 ? 'the 1 page' : `all ${pages} pages`
      } with a header, as expected.`,
    headerBarsEdited: (actual: string, edited: number, pages: number, expected: string) =>
      `Header bars copy as ${actual} on ${
        edited < pages ? `${edited} of ${pages}` : pages === 1 ? 'the 1' : `all ${pages}`
      } ${pages === 1 ? 'page' : 'pages'} with a header. Expected ${expected}.`,
    expectedStatement: 'Expected statement',
    separatorBars: 'Separator bars',
    documentBars: (bars: number) => `This document · ${bars} ${bars === 1 ? 'bar' : 'bars'}`,
    noHeaderLine: 'No header line found',
    embeddedFontsHowTo:
      'To check yourself: open X-Ray, go to the Bytecode tab and search for FontDescriptor.',
    noFonts: 'No font descriptors came back'
  }
} as const;
